import { Injectable } from '@angular/core';

import { DictionaryInterface } from '../data';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class DictionaryCacheRepository extends MemoryCacheRepository<DictionaryInterface[]> {}
